var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_fig",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.064,
    height: 27.309,
    viewBox: "0 0 109.064 27.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_165",
    "data-name": "\\u9577\\u65B9\\u5F62 165",
    width: 109.064,
    height: 27.309,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_136",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 136",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_284",
    "data-name": "\\u30D1\\u30B9 284",
    d: "M335.375,16.508c-2.22,0-4.456.015-6.691-.01a6.072,6.072,0,0,1-1.786-.233,2.647,2.647,0,0,1,.537-5.135c3.9-.079,7.8-.1,11.7,0,1.509.038,2.331,1.314,2.323,3.071a13.634,13.634,0,1,1-2.9-8.841,2.667,2.667,0,0,1-.208,3.928c-1.246,1.039-2.789.824-4-.556-3.189-3.633-7.766-4.238-11.506-1.519a8.249,8.249,0,0,0-2.9,9.058,8.363,8.363,0,0,0,7.2,5.72,8.213,8.213,0,0,0,8.276-5.077c.027-.069-.013-.164-.037-.4",
    transform: "translate(-232.395 -0.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_285",
    "data-name": "\\u30D1\\u30B9 285",
    d: "M165.6,10.658h2.161c2.99,0,5.98-.012,8.969,0,1.828.011,3.033,1.1,3.029,2.673,0,1.6-1.164,2.645-3.037,2.66-3.25.024-6.5.008-9.749.008h-1.546c0,2.63,0,5.09,0,7.551,0,2.516-.937,3.788-2.751,3.747-1.789-.04-2.63-1.228-2.63-3.72,0-4.246-.01-8.493,0-12.739A10.772,10.772,0,0,1,170.719.02c2.643-.031,5.286-.018,7.93,0a2.745,2.745,0,0,1,3.016,2.693,2.816,2.816,0,0,1-3.016,2.742c-2.686.032-5.374-.027-8.059.029a5.027,5.027,0,0,0-4.993,5.177",
    transform: "translate(-118.399 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_286",
    "data-name": "\\u30D1\\u30B9 286",
    d: "M49.747,64.859c-1.949,0-3.9.017-5.846,0-1.842-.021-2.611-.95-2.222-2.77q.853-4,1.83-7.965a3.3,3.3,0,0,1,3.314-2.6q6.04-.082,12.082,0c1.744.023,2.479,1.037,2.1,2.778q-.85,3.93-1.809,7.837a3.367,3.367,0,0,1-3.475,2.726c-1.992.022-3.984,0-5.976,0",
    transform: "translate(-30.762 -38.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_287",
    "data-name": "\\u30D1\\u30B9 287",
    d: "M3.155,26.787c-.173,0-.346,0-.52,0C.4,26.773-.354,25.816.15,23.664q1.389-5.934,2.762-11.871C3.6,8.845,4.262,5.894,4.959,2.95A3.468,3.468,0,0,1,8.651,0c3.815-.05,4.24.476,3.373,4.249Q9.775,14.044,7.5,23.831c-.5,2.142-1.707,2.955-4.35,2.956",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_288",
    "data-name": "\\u30D1\\u30B9 288",
    d: "M266.2,13.625c0-3.467-.008-6.935,0-10.4.006-1.956,1.032-3.148,2.675-3.158s2.746,1.181,2.754,3.118q.04,10.467,0,20.934c-.01,2.192-1.385,3.512-3.166,3.192a2.661,2.661,0,0,1-2.257-2.892c-.021-3.6-.007-7.195-.007-10.792",
    transform: "translate(-196.938 -0.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_289",
    "data-name": "\\u30D1\\u30B9 289",
    d: "M70.892.928c1.946,0,3.893-.008,5.839,0,1.819.01,2.528.893,2.181,2.686-.1.5-.166,1.01-.277,1.509a3.319,3.319,0,0,1-3.528,2.882q-5.45.033-10.9,0c-2.2-.01-2.925-1-2.619-3.17.2-1.454.411-2.82,1.893-3.528A3.324,3.324,0,0,1,64.793.945c2.032-.038,4.066-.017,6.1-.017",
    transform: "translate(-45.515 -0.683)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFig);
export default __webpack_public_path__ + "static/media/logo_fig.5fc34576622e3563d66a2bba561abcca.svg";
export { ForwardRef as ReactComponent };